import script from "./MessageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageItem.vue?vue&type=script&setup=true&lang=js"

import "./MessageItem.vue?vue&type=style&index=0&id=a20841ae&lang=scss"

const __exports__ = script;

export default __exports__